/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonPersonidSharedClassStudentsDropdown200,
  GetApiV1PersonPersonidSharedClassStudentsDropdown401,
  GetApiV1PersonPersonidSharedClassStudentsDropdown404,
  GetApiV1PersonPersonidSharedClassStudentsDropdown500,
  GetApiV1PersonPersonidSharedClassStudentsDropdownPathParams,
  GetApiV1PersonPersonidSharedClassStudentsDropdownQueryParams,
  GetApiV1PersonPersonidSharedClassStudentsDropdownQueryResponse,
} from "../../types/personSharedController/GetApiV1PersonPersonidSharedClassStudentsDropdown.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

export const getApiV1PersonPersonidSharedClassStudentsDropdownPathParamsSchema =
  z.object({
    personId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1PersonPersonidSharedClassStudentsDropdownPathParams>;

export const getApiV1PersonPersonidSharedClassStudentsDropdownQueryParamsSchema =
  z
    .object({
      companyId: z.optional(z.coerce.number().int()),
    })
    .optional() as unknown as ToZod<GetApiV1PersonPersonidSharedClassStudentsDropdownQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonPersonidSharedClassStudentsDropdown200Schema =
  z.array(
    z.lazy(() => dropDownRepositoryResponseSchema),
  ) as unknown as ToZod<GetApiV1PersonPersonidSharedClassStudentsDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonPersonidSharedClassStudentsDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonPersonidSharedClassStudentsDropdown401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1PersonPersonidSharedClassStudentsDropdown404Schema =
  z.any() as unknown as ToZod<GetApiV1PersonPersonidSharedClassStudentsDropdown404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonPersonidSharedClassStudentsDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonPersonidSharedClassStudentsDropdown500>;

export const getApiV1PersonPersonidSharedClassStudentsDropdownQueryResponseSchema =
  z.lazy(
    () => getApiV1PersonPersonidSharedClassStudentsDropdown200Schema,
  ) as unknown as ToZod<GetApiV1PersonPersonidSharedClassStudentsDropdownQueryResponse>;
